import { gql } from '@apollo/client'

const RegionFragment = gql`
  fragment region on Region {
    id
    name
    age_of_consent
    iso_code
    default_phone_country_code
    __typename
  }
`

export default RegionFragment
